/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {CTCEntity} from '@ion/core/src/types/entities';
import useBulkDeleteResults from './useBulkDeleteResults';
import useBulkEditResults from './useBulkEditResults';
import useBulkImportResults from './useBulkImportResults';
import useBulkMoveResults from './useBulkMoveResults';

// defines the prop definitions for bulk operation results ...
export type BulkOperationResults = {
  bulkEditResult: CTCEntity | CTCEntity[] | null;
  bulkDeleteResult: CTCEntity | CTCEntity[] | null;
  bulkImportResult: CTCEntity | CTCEntity[] | null;
  bulkMoveResult: CTCEntity | CTCEntity[] | null;
};

/**
 * Provides a utility hook for getting the bulk operation results for any entity via
 * its respective reducer ...
 *
 * ```typescript
 *
 *   import {useBulkOperationResults} from '@ion/dls/src/hooks/';
 *   const {
 *     bulkEditResult,
 *     bulkDeleteResult,
 *     bulkImportResult
 *   } = useBulkOperationResults('reducer');
 *
 * ```
 */
export const useBulkOperationResults = (reducer: string): BulkOperationResults => {
  return {
    bulkEditResult   : useBulkEditResults(reducer),
    bulkDeleteResult : useBulkDeleteResults(reducer),
    bulkImportResult : useBulkImportResults(reducer),
    bulkMoveResult   : useBulkMoveResults(reducer)
  };
};

export default useBulkOperationResults;
